export const DueGroupTypes = {
  SHOW_DUE_GROUP: "SHOW_DUE_GROUP",
  ADD_DUE_GROUP: "ADD_DUE_GROUP",
  UPDATE_DUE_GROUP: "UPDATE_DUE_GROUP",
  DELETE_DUE_GROUP: "DELETE_DUE_GROUP",
  LIST_TYPES:"LIST_TYPES",
  LIST_APARTMENT:'LIST_APARTMENT'
};
